import { useField } from "formik";
import { useContext } from "react";
import { RfxContext } from "newui/features/Rfx/context/RfxContext";

interface UseSmartFieldSelectionOptions {
	shouldSubmit?: boolean;
}

interface UseSmartFieldSelectionReturn {
	error: string | undefined;
	isSelected: (listValue: number) => boolean;
	isSubmitting: boolean;
	selectHandler: (listValue: number) => Promise<void>;
	touched: boolean;
	value: number[];
}

export const useSmartFieldSelection = (
	props: { name: string },
	options: UseSmartFieldSelectionOptions = {}
): UseSmartFieldSelectionReturn => {
	const { shouldSubmit = false } = options;
	// eslint-disable-next-line
	const [field, meta, helper] = useField<number[]>(props);
	const { value, error, touched } = meta;
	const { setValue, setTouched } = helper;
	const { saveHandler } = useContext(RfxContext);

	const isSelected = (listValue: number): boolean =>
		Array.isArray(value) && value.length > 0
			? value.includes(listValue)
			: false;

	const selectHandler = async (listValue: number): Promise<void> => {
		setTouched(true);
		let updated: number[];
		if (isSelected(listValue)) {
			updated = value.filter((val) => val !== listValue);
		} else {
			updated = Array.isArray(value) ? [...value, listValue] : [listValue];
		}
		setValue(updated);
		if (shouldSubmit && saveHandler) {
			setTimeout(async () => {
				await saveHandler();
			}, 0);
		}
	};

	return {
		value,
		error,
		touched,
		isSelected,
		selectHandler,
		isSubmitting: false,
	};
};
